import { render, staticRenderFns } from "./Func16Listagem.vue?vue&type=template&id=6f5b6ca8"
import script from "./Func16Listagem.vue?vue&type=script&lang=js"
export * from "./Func16Listagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports